import React from 'react';
import ReactDOM from 'react-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { Provider } from 'react-redux';
import configureStore from './redux/store';
import injectTapEventPlugin from 'react-tap-event-plugin';
import App from './App';
import './styles/index.css';

injectTapEventPlugin();
const store = configureStore()

ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider>
      <App />
    </MuiThemeProvider>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js